import React from 'react';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import MoleculeDivToggle from '../../shared/component/molecule/MoleculeDivToggle';
import { getSettingsMessage } from '../../shared/constants/pageMessages';
import {
  SettingsSection,
  SubContainer,
  SubExplain,
  SubTitle,
  SubWrapper,
  Title,
} from './MemberSetting';

const Notification: React.FC = () => {
  const { user } = useAuth();
  const { setting, updateNotification } = useSetting();

  if (!user || !setting) return null;

  const handleMarketingEmailChange = async (value: boolean) => {
    await updateNotification({
      marketingEmail: value
    });
  };

  return (
    <SettingsSection>
      <Title>Notification</Title>
      <SubContainer>
        <SubWrapper>
          <SubTitle>{getSettingsMessage('SETTINGS_MARKETING')}
            <SubExplain>
              {getSettingsMessage('MARKETING_EMAIL_EXPLAIN')}
            </SubExplain>
          </SubTitle>
          <MoleculeDivToggle
            value={Boolean(setting.marketingEmail)}
            name={"Email"}
            handleToggle={(e) => handleMarketingEmailChange(e.target.checked)}
          />
        </SubWrapper>
      </SubContainer>
    </SettingsSection>
  );
}

export default Notification;
